import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// TODO: типы вынести в types
import { UsersSearchParameters } from '@src/api';
import { SearchUsersService } from '@src/app/modules/search-users';
import { ActionItemModel } from '@src/app/modules/actions';
import { Nullable, Optional } from '@src/types/utils';

import { ApiService, DialogService, PermissionService, StoreService } from '../../services';
import { mapUserUIToUserModel } from '../../utils';
import { ChatMemberModel, ChatPermissionsModel } from '../types';

@Component({
  selector: 'chat-administrations-list',
  templateUrl: './chat-administrations-list.component.html',
  styleUrls: ['./chat-administrations-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatAdministrationsListComponent implements OnChanges, OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly searchUsersService = inject(SearchUsersService);
  private readonly apiService = inject(ApiService);
  private readonly dialogService = inject(DialogService);
  private readonly store = inject(StoreService);
  private readonly translateService = inject(TranslateService);
  private readonly permissionService = inject(PermissionService);

  @Input() chatId?: string;
  @Input() permissions?: Nullable<ChatPermissionsModel>;

  administrations: Optional<Nullable<Array<ChatMemberModel>>>;

  headerActions: ActionItemModel[] = [];
  itemActions: ActionItemModel[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chatId']) {
      if (this.chatId) {
        this.refresh();
      }
    }

    if (changes['permissions']) {
      this.setHeaderActions();
      this.setItemActions();
    }

    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    this.store.chatMembers$.subscribe(chatMembers => {
      this.administrations = Object.keys(chatMembers).length ? Object.values(chatMembers[this.chatId!]) : [];
      this.cdr.markForCheck();
    });
  }

  openAddAdminsDialog() {
    // TODO: сделать emit во вне

    const filter: UsersSearchParameters = {};
    const excludeUsersIds = this.administrations?.map(member => member.userId);

    this.searchUsersService
      .searchMultiple(undefined, undefined, excludeUsersIds, undefined, filter)
      .subscribe(users => {
        if (!users?.length) return;

        if (this.chatId && users.length) {
          const administrations = mapUserUIToUserModel(users);
          if (administrations.length) {
            administrations.map(admin => {
              this.makeAdmin(admin);
            });
          } else {
            // TODO: вывести ошибку
          }
        }
        this.cdr.markForCheck();
      });
  }

  openConfirmMakeAdminDialog(member: ChatMemberModel): void {
    this.dialogService.confirmMakeAdminDialog.subscribe({
      next: res => {
        if (res) {
          this.makeAdmin(member);
        }
      },
    });
  }

  openConfirmDemoteAdminDialog(userId: string): void {
    this.dialogService.confirmDemoteAdminDialog.subscribe({
      next: res => {
        if (res) {
          this.demoteAdmin(userId);
        }
      },
    });
  }

  private setHeaderActions() {
    this.headerActions = [
      {
        title: this.translateService.instant('components.internalMessenger.buttons.addAdmins'),
        icon: 'user-plus',
        visible: () => {
          return !!this.permissions?.canManageAdmins;
        },
        action: () => {
          this.openAddAdminsDialog();
        },
      },
    ];
  }

  private setItemActions() {
    this.itemActions = [
      {
        title: this.translateService.instant('components.internalMessenger.buttons.demoteAdmin'),
        icon: 'shield-x',
        color: 'var(--int-mes-color-red)',
        visible: (item: ChatMemberModel) => {
          return (
            !!this.permissions?.canManageAdmins && !!item.isChatAdmin && !this.permissionService.isAuthUser(item.userId)
          );
        },
        action: (item: ChatMemberModel) => {
          this.openConfirmDemoteAdminDialog(item.userId);
        },
      },
    ];
  }

  private makeAdmin(member: ChatMemberModel) {
    if (!this.chatId) {
      // TODO: вывести ошибку
      return;
    }

    this.apiService.addAdmin({ chatId: this.chatId, userId: member.userId }).subscribe();
  }

  private demoteAdmin(userId: string) {
    if (!this.chatId) {
      // TODO: вывести ошибку
      return;
    }

    this.apiService.removeAdmin({ chatId: this.chatId, userId }).subscribe();
  }

  private refresh() {
    if (!this.chatId) {
      // TODO: вывести ошибку
      return;
    }

    this.apiService.getChatMembers(this.chatId).subscribe();
  }
}
